import { useSelector } from "react-redux"
import * as React from "react"

// const MessageSvg = () => {

//     const {theme} = useSelector(state => state.layout)


//     return (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width={29}
//             height={26}
//             fill={theme === "dark" ? "#fff" : "#000"}
//         >
//             <g clipPath="url(#a)">
//             <path
//                 fill={theme === "dark" ? "#fff" : "#000"}
//                 fillOpacity={0.85}
//                 d="M4.982 26c1.51 0 5.272-1.634 7.41-3.155.215-.15.39-.212.567-.212.163.013.327.025.49.025 9.072 0 15.085-5.113 15.085-11.323C28.534 5.063 22.194 0 14.267 0 6.341 0 0 5.063 0 11.335c0 3.99 2.479 7.495 6.517 9.64.189.1.252.286.151.473-.704 1.148-1.963 2.52-2.44 3.143-.491.623-.215 1.409.754 1.409Z"
//             />
//             </g>
//             <defs>
//             <clipPath id="a">
//                 <path fill={theme === "dark" ? "#fff" : "#000"} d="M0 0h29v26H0z" />
//             </clipPath>
//             </defs>
//         </svg>
//         )
//     }
  
// export default MessageSvg

const MessageSvg = () => {

    const {theme} = useSelector(state => state.layout)

    return(
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={22}
            height={21}
            fill={theme === "dark" ? "#fff" : "#000"}
        >
            <path
            fill={theme === "dark" ? "#fff" : "#000"}
            d="M3.682 15.354a1.375 1.375 0 0 1 .395 1.102c-.097.931-.28 1.852-.547 2.75 1.918-.444 3.09-.959 3.621-1.228.302-.153.65-.19.977-.102.936.25 1.902.377 2.872.374 5.494 0 9.625-3.86 9.625-8.25 0-4.39-4.13-8.25-9.625-8.25S1.375 5.611 1.375 10c0 2.018.848 3.891 2.307 5.354Zm-.678 5.37a30.15 30.15 0 0 1-.98.177c-.275.044-.484-.242-.375-.498.121-.288.233-.58.335-.876l.004-.013c.341-.99.619-2.129.72-3.189C1.023 14.634 0 12.42 0 10 0 4.684 4.925.375 11 .375S22 4.685 22 10c0 5.316-4.925 9.625-11 9.625a12.376 12.376 0 0 1-3.227-.42c-.715.36-2.254 1.02-4.769 1.519Z"
            />
        </svg>
    )}
export default MessageSvg

